type Props = { children?: React.ReactNode; label: string; required?: boolean; classes?: string };
export const FormGroup = (props: Props) => {
  return (
    <div className={`form-group ${props.classes}`}>
      <label>
        {props.label}
        {props.required && <span className="text-danger">*</span>}
      </label>
      {props.children}
    </div>
  );
};
